import React, { useEffect } from "react";
import { CgMathMinus, CgMathPlus } from "react-icons/cg";

import { useNavigate } from "react-router-dom";
import { setVehicle } from "../../redux/slices/addVehicleSlice";
import { useDispatch } from "react-redux";

const Pricing: React.FC = () => {
  const [lowPrice, setLowPrice] = React.useState<number>(15);
  const [mediumPrice, setMediumPrice] = React.useState<number>(50);
  const [highPrice, setHighPrice] = React.useState<number>(50);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setVehicle({
        maxPricePerHour: highPrice,
        minPricePerHour: lowPrice,
      })
    );
  }, [highPrice, lowPrice, dispatch]);

  const navigate = useNavigate();
  return (
    // SUBJECT TO REVISION

    <>
      <div className="flex w-[80%] lg:w-[70%] xl:w-[50%] py-10 border rounded-2xl mx-auto justify-center  h-full  flex-col gap-2 lg:items-center  bg-white">
        <p className=" text-black text-center font-Poppins font-semibold lg:font-medium text-[17px] md:text-[25px] lg:text-[40px]  ">
          How does the pricing work?
        </p>
        {/* <div className="flex flex-col  gap-7 w-[90%] mx-auto  lg:w-2/3 ">
        <div className="flex flex-wrap w-full gap-3">
          <ul className=" list-disc list-inside flex  flex-col gap-3">
            <li className="justify-between w-full font-Poppins text-black text-[14px] lg:text-[24px] font-bold leading-[45px] ">
              You set a daily price for your vehicle
            </li>
            <li className=" justify-between w-full font-Poppins text-black text-[14px] lg:text-[24px] font-bold leading-[45px]  ">
              We work out the booking price for the renter
              <p className="text-[15px] font-medium leading-3 ">
                Based on your prices per day and extra costs like insurance
              </p>
            </li>
            <li className="justify-between w-full font-Poppins text-black text-[14px] lg:text-[24px] font-bold leading-[45px] ">
              We take a $25% service fee
              <p className="text-[15px] font-medium leading-3 ">
                This is deducted from your earning after the rental
              </p>
            </li>
            <li className="justify-between w-full font-Poppins text-black text-[14px] lg:text-[24px] font-bold leading-[45px] ">
              We compensate you for any extra costs
              <p className="text-[15px] font-medium leading-3 ">
                Like missing fuel or penalties or extra mileage
              </p>
            </li>
          </ul>
        </div>
      </div> */}
        <div className="flex flex-col pt-5 gap-4">
          <p className="w-[90%] mx-auto lg:w-[60%]  text-black text-center font-Poppins font-semibold lg:font-medium text-[16px] md:text-[20px] lg:text-[30px]  ">
            Set your prices per day according to demand
          </p>
          <div className="w-[80%] lg:w-full mx-auto flex flex-col gap-12">
            {/* <div className="flex justify-between">
              <div className="flex flex-col gap-2">
                <div className="flex gap-2">
                  <span className="w-[20px] h-[20px] lg:h-[28px] lg:w-[28px] bg-[rgba(95,74,229,0.29)] "></span>
                  <span className="text-black font-Poppins font-bold text-[14px] lg:text-[24px] ">
                    Low
                  </span>
                </div>
                <p className="text-black font-Poppins font-normal text-[10px] lg:text-[20px] ">
                  For instance, Weekday's in school terms.{" "}
                </p>
              </div>
              <div className="flex gap-2 lg:gap-5 items-center">
                <CgMathMinus
                  color="black"
                  size={25}
                  className=" bg-lightGreyText border rounded-full cursor-pointer p-1"
                  onClick={() => {
                    lowPrice > 0 && setLowPrice(lowPrice - 1);
                  }}
                />
                <span className="text-midGreen font-Poppins text-[18px] lg:text-[24px] font-semibold ">
                  ${lowPrice}
                </span>
                <CgMathPlus
                  color="black"
                  size={25}
                  className=" bg-lightGreyText border rounded-full cursor-pointer p-1"
                  onClick={() => {
                    setLowPrice(lowPrice + 1);
                  }}
                />
              </div>
            </div>
            <div className="flex justify-between">
              <div className="flex flex-col gap-2">
                <div className="flex gap-2">
                  <span className="w-[20px] h-[20px] lg:h-[28px] lg:w-[28px] bg-[rgba(95,74,229,0.71)] "></span>
                  <span className="text-black font-Poppins font-bold text-[14px] lg:text-[24px] ">
                    Medium
                  </span>
                </div>
                <p className="text-black font-Poppins font-normal text-[10px] lg:text-[20px] ">
                  For instance, Weekday's in school terms.{" "}
                </p>
              </div>
              <div className="flex gap-2 lg:gap-5 items-center">
                <CgMathMinus
                  color="black"
                  size={25}
                  className=" bg-lightGreyText border rounded-full cursor-pointer p-1"
                  onClick={() => {
                    mediumPrice > lowPrice && setMediumPrice(mediumPrice - 1);
                  }}
                />
                <span className="text-midGreen font-Poppins text-[18px] lg:text-[24px] font-semibold ">
                  ${mediumPrice}
                </span>
                <CgMathPlus
                  color="black"
                  size={25}
                  className=" bg-lightGreyText border rounded-full cursor-pointer p-1"
                  onClick={() => {
                    setMediumPrice(mediumPrice + 1);
                  }}
                />
              </div>
            </div> */}
            <div className="flex justify-between">
              <div className="flex flex-col gap-2">
                <div className="flex gap-2">
                  <span className="w-[20px] h-[20px] lg:h-[28px] lg:w-[28px] bg-midGreen "></span>
                  <span className="text-black font-Poppins font-bold text-xs md:text-[14px] lg:text-[24px] ">
                    Minimum price
                  </span>
                </div>
                {/* <p className="text-black font-Poppins font-normal text-[10px] lg:text-[20px] ">
                  For instance, Weekday's in school terms.{" "}
                </p> */}
              </div>
              <div className="flex whitespace-nowrap gap-2 lg:gap-5 items-center">
                <CgMathMinus
                  color="black"
                  size={25}
                  className=" bg-lightGreyText border rounded-full cursor-pointer p-1"
                  onClick={() => {
                    lowPrice > 0 && setLowPrice(lowPrice - 1);
                  }}
                />
                <span className="text-midGreen font-Poppins max-w-fit flex flex-row  text-[18px] lg:text-[24px] font-semibold ">
                  $
                  <input
                    aria-label="lowPrice"
                    type="number"
                    value={lowPrice}
                    onChange={(e) => setLowPrice(e.target.valueAsNumber)}
                    className=" outline-none border-none w-10"
                  />
                </span>
                <CgMathPlus
                  color="black"
                  size={25}
                  className=" bg-lightGreyText border rounded-full cursor-pointer p-1"
                  onClick={() => {
                    setLowPrice(lowPrice + 1);
                  }}
                />
              </div>
            </div>
            <div className="flex justify-between">
              <div className="flex flex-col gap-2">
                <div className="flex gap-2">
                  <span className="w-[20px] h-[20px] lg:h-[28px] lg:w-[28px] bg-midGreen "></span>
                  <span className="text-black font-Poppins font-bold text-xs md:text-[14px] lg:text-[24px] ">
                    Maximum price
                  </span>
                </div>
                {/* <p className="text-black font-Poppins font-normal text-[10px] lg:text-[20px] ">
                  For instance, Weekday's in school terms.{" "}
                </p> */}
              </div>
              <div className="flex whitespace-nowrap gap-2 lg:gap-5 items-center">
                <CgMathMinus
                  color="black"
                  size={25}
                  className=" bg-lightGreyText border rounded-full cursor-pointer p-1"
                  onClick={() => {
                    highPrice > lowPrice && setHighPrice(highPrice - 1);
                  }}
                />
                <span className="text-midGreen font-Poppins max-w-fit flex flex-row text-[18px] lg:text-[24px] font-semibold ">
                  $
                  <input
                    aria-label="highPrice"
                    type="number"
                    value={highPrice}
                    onChange={(e) => setHighPrice(e.target.valueAsNumber)}
                    className=" outline-none border-none w-10"
                  />
                </span>
                <CgMathPlus
                  color="black"
                  size={25}
                  className=" bg-lightGreyText border rounded-full cursor-pointer p-1"
                  onClick={() => {
                    setHighPrice(highPrice + 1);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pricing;
